import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { PostHogProvider } from 'posthog-js/react';
const options = {
  api_host: 'https://us.i.posthog.com',
  defaults: '2025-05-24'
};
render(<PostHogProvider apiKey="phc_4cBjZ0ovPiViLpt2jFhcOGcAyS0SaIct5H5TjJMzQJu" options={options} data-id="element-346">

    <App data-id="element-347" />
  </PostHogProvider>, document.getElementById('root'));